import store from '@/store/store'

const globalUrl = process.env.NODE_ENV === 'production' ? '' : 'ipa/'
const globalUrl2 = process.env.NODE_ENV === 'production' ? '' : 'api/'

/**
 * @method:修改路由的meta属性，keep-alive使用
 * @params _this:页面this
 * @params route：要跳转页面路由name属性
 */
const setRouteMeta = (_this, route) => {
  let routesList = _this.$router.options.routes[3].children
  routesList.forEach(element => {
    if (element.name === route) element.meta.isNav = false
  })
}
/**
* @method:添加页面路径，图标等，用于登录后侧边栏路由赋予，首页图标赋予路径，图标及权限判断
* @params e:二级目录对象
* @params type：类型，login表只获取路径，allMuneAndRight用于获取图标等，right判断该菜单是否要判断权限
*/
const getMuneRight = (e, type, right) => {
  let returnMeg = ''
  let rightName
  switch (e.id) {
    case '10013':
      returnMeg = type === 'login' ? '/declareDutiableRecode' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_03.png') })
      break
    case '10014':
      returnMeg = type === 'login' ? '/incomeAccount' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_05.png') })
      break
    case '10076':
      if (right) rightName = 'endRecordRight'
      returnMeg = type === 'login' ? '/endDeclareRecode' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_07.png') })
      break
    case '10167':
      returnMeg = type === 'login' ? '/taxInvoice' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_09.png') })
      break
    case '10015':
      returnMeg = type === 'login' ? '/taxpayerList' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_13.png') })
      break
    case '10064':
      returnMeg = type === 'login' ? '/taxpayerApproval' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_11.png') })
      break
    case '10017':
      returnMeg = type === 'login' ? '/commercialIndex' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_29.png') })
      break
    case '10170':
      returnMeg = type === 'login' ? '/merchantBalance' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_22.png') })
      break
    case '10018':
      returnMeg = type === 'login' ? '/statisticalForm' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_61.png') })
      break
    case '10068':
      returnMeg = type === 'login' ? '/declareStatistiacal' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_64.png') })
      break
    case '10088':
      returnMeg = type === 'login' ? '/capitalFlow' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_66.png') })
      break
    case '10158':
      returnMeg = type === 'login' ? '/accountStatement' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_73.png') })
      break
    case '10091':
      returnMeg = type === 'login' ? '/otherPayOrder' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_27.png') })
      break
    case '10092':
      returnMeg = type === 'login' ? '/rechargeRecode' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_34.png') })
      break
    case '10019':
      returnMeg = type === 'login' ? '/operatorList' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_78.png') })
      break
    case '10020':
      returnMeg = type === 'login' ? '/roleList' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_74.png') })
      break
    case '10123':
      if (right) rightName = 'taskRight'
      returnMeg = type === 'login' ? '/order' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_24.png') })
      break
    case '10124':
      returnMeg = type === 'login' ? '/orderImport' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_31.png') })
      break
    case '10132':
      if (right) rightName = 'messageRight'
      returnMeg = type === 'login' ? '/message' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_45.png') })
      break
    case '10144':
      if (right) rightName = 'invoiceRight'
      returnMeg = type === 'login' ? '/invoiceManage' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_37.png') })
      break
    case '10171':
      returnMeg = type === 'login' ? '/invoiceApply' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_40.png') })
      break
    case '10165':
      returnMeg = type === 'login' ? '/supervisionPerson' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_42.png') })
      break
    case '10166':
      returnMeg = type === 'login' ? '/supervisionCompany' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_58.png') })
      break
    case '15001':
      returnMeg = type === 'login' ? '/agent' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_58.png') })
      break
    case '15002':
      returnMeg = type === 'login' ? '/income' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_58.png') })
      break
    case '15003':
      returnMeg = type === 'login' ? '/settlement' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_58.png') })
      break
    case '15020':
      returnMeg = type === 'login' ? '/agencyStatistics' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_58.png') })
      break
  }
  if (type === 'login' || (type !== 'login' && !right)) return returnMeg
  let returnObj = {}
  returnObj.returnMeg = returnMeg
  returnObj.rightName = rightName
  return returnObj
}
/**
* @method:各个页面的权限判断
* @params _id  {string} 要校验权限id
* @return {boolean} 是否有权限
*/
const getIndependentRight = (id) => {
  let delayeringMune = store.state.delayeringMune
  let rightRes = false
  delayeringMune.forEach(e => {
    if (e.id === id) rightRes = true
  })
  return rightRes
}
export default {
  globalUrl,
  globalUrl2,
  setRouteMeta,
  getMuneRight,
  getIndependentRight
}



// WEBPACK FOOTER //
// ./src/utils/global.js